import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { CardActionLink } from '@/common/components/CardActionLink/CardActionLink';
import { IllustrationImage } from '@/common/components/Illustrations/IllustrationImage';
import { ModalLearning } from '@/common/components/ModalLearning/ModalLearning';
import { TOverlayRef } from '@/common/components/Overlay/Overlay.types';
import { Stack } from '@/common/components/Stack/Stack';
import { Translate } from '@/common/components/Translate/Translate';
import { ROUTES } from '@/common/constants/routes';
import { AnalyticsService } from '@/common/integrations/analytics/analytics.service';

export function ITSinglePaymentOnboardingModal() {
  const { t } = useTranslation();
  const modalRef = useRef<TOverlayRef>(null);
  const [open, setOpen] = useState(true);

  if (!open) {
    return null;
  }

  return (
    <ModalLearning.Root
      onClose={() => {
        setOpen(false);
      }}
      modalRef={modalRef}
    >
      <ModalLearning.Step
        title={t('dashboard.home.it.single_payment_modal.onboarding.title')}
        description={
          <Stack gap="xl">
            <Translate
              parent={BodyText}
              i18nKey={t(
                'dashboard.home.it.single_payment_modal.onboarding.description'
              )}
            />
            <CardActionLink
              className="sm:mb-md"
              title={t(
                'dashboard.home.it.single_payment_modal.onboarding.card_title'
              )}
              description={t(
                'dashboard.home.it.single_payment_modal.onboarding.card_description'
              )}
              href={ROUTES.MEAL_VOUCHER_PAYMENT_AUTOMATIC}
              onPress={() => {
                AnalyticsService.trackCustomEvent(
                  'single_transaction_launching_strategy_post_onboarding_learning_center_page_link_card_button_clicked'
                );
                modalRef.current?.close();
              }}
            />
          </Stack>
        }
        asset={
          <IllustrationImage
            source={require('@/assets/illustrations/illustration-cards-alert.png')}
            transition={250}
          />
        }
        onShow={() => {
          AnalyticsService.trackPageView(
            'single_transaction_launching_strategy_post_onboarding_learning_center_page'
          );
        }}
      />
    </ModalLearning.Root>
  );
}
